import { TableField } from "../../table-field";

export const fieldsDocumento: TableField[] = [
  {
    key: "TipoLegislacao.Descricao",
    label: "Legislação",
    tdClass: ["align-middle", "quebrarPorPalavra"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "TipoAto.Descricao",
    label: "Ato",
    tdClass: ["align-middle", "quebrarPorPalavra"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "Nome",
    label: "Nome do Arquivo",
    tdClass: ["align-middle", "quebrarPorLetra"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "NroAno",
    label: "Número/Ano",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "demais",
    label: "Demais Dados",
    tdClass: ["align-middle", "text-left", "text-lg-right", "quebrarPorPalavra"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: false,
  },
  {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
  },
];
